module.exports={graphics:"This website uses graphics which are licensed as follows",title:"Licenses of third parties"};